<ng-container *ngIf="showSkeleton">
  <div
    class="d-flex align-items-center"
    style="margin-bottom: 12px">
    <div
      class="placeholder-pill"
      style="width: 100px; height: 10px"></div>
    <div class="flex-grow-1"></div>
    <div
      class="placeholder-pill"
      style="width: 160px; height: 14px"></div>
  </div>
  <div
    class="placeholder-pill"
    style="width: 260px; height: 12px; margin-bottom: 12px"></div>
  <div
    class="placeholder-pill"
    style="width: 220px; height: 10px; margin-bottom: 10px"></div>
  <div class="box-shadow-skeleton-copy"></div>
  <div class="flex-grow-1"></div>
  <div class="d-flex justify-end">
    <div
      class="placeholder-pill"
      style="
        width: 90px;
        height: 14px;
        margin-bottom: 12px;
        margin-right: 12px;
      "></div>
  </div>
</ng-container>
